module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-8",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-container"
  }, [_c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_1"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_3"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_4"
  }, [_vm._v(" ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e84d099"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Circle8.vue
// module id = 913
// module chunks = 170